import { useMemo, useState } from 'react';
import moment from 'moment';

import { user } from 'services';
// import { deleteSubscription } from 'services/payments-service';
import { TableExt, TableInfo, /*Confirm,*/ themes, GridBox, GridUpdateMessage } from 'libs/ui';
import { getTableParams } from './grid.params';
import ReplaceWindow from './forms/replace-window';
import RfidForm from './forms/rfid-form';
import { useTranslation } from 'react-i18next';

export const RfidGrid = (props) => {
  const { count, entries, className, theme, getXlsAction, clientId, updateEntry } = props;
  const [showForm, setShowForm] = useState('');
  const [message, setMessage] = useState('');
  const [row, setRow] = useState({});

  const { t } = useTranslation();

  const rightEdit = user.haveRight('rfid.update');

  /**
   * hide replace form with message
   */
  const closeReplaceForm = (success = false) => {
    closeForm();
    if (success) {
      setMessage('Изменение сохранено');
      setTimeout(() => setMessage(''), 3000);
    }
  };

  /**
   * add record
   */
  const addItemAction = () => {
    setRow({});
    setShowForm('addForm');
  };

  /**
   * edit record
   * @param {*} row
   */
  const editItemAction = (row) => {
    row.mean_id = row.rfid;
    setRow(row);
    setShowForm('editForm');
  };

  /**
   * close form
   * @returns
   */
  const closeForm = () => setShowForm('');

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const actions = [];
  if (user.haveRight('rfid.update')) {
    actions.push({
      isVisible: (row) => row.status !== 'blocked_by_client',
      getTitle: (row) => (row.is_blocked ? t('buttons.Разблокировать ') : t('buttons.Заблокировать ')),
      action: 'status', //() => setShowForm('statusForm'),
      actionType: 'rfid',
    });
  }

  if (!clientId) {
    if (user.haveRight('rfid.update') && user.haveRight('clients.view')) {
      actions.push({
        title: t('buttons.Перейти в карточку клиента'),
        action: (row) => {
          window.location = '/card/client?id=' + row.client_id;
        },
      });
    }
  }

  // top actions
  // const rightAdd = user.haveRight('rfid.add');
  const topActions = [];
  if (!clientId) {
    // if (rightAdd && count) {
    //   topActions.push({
    //     title: t('buttons.Заменить тариф у RFID'),
    //     icon: 'fa-exchange',
    //     theme: themes.blue,
    //     action: replaceAction,
    //   });
    // }
    if (count) {
      getXlsAction(topActions);
    }
  } else {
    topActions.push({ title: t('buttons.Добавить RFID'), icon: 'fa-plus', theme: themes.blue, action: addItemAction });
  }

  const tableParams = useMemo(() => getTableParams(t), [t]);
  // const initial = showForm === 'addForm' ? {} : { ...row };
  const initial =
    showForm === 'addForm'
      ? {
          start_at: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          end_at: moment().add(1, 'month').add(-1, 'day').format('YYYY-MM-DD 23:59:59'),
        }
      : { ...row };

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        updateEntry={updateEntry}
        theme={theme}
        title="RFID"
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        onRowClick={rightEdit ? editItemAction : undefined}
        clientId={props.clientId}
        {...tableParams}
      />

      {/* {confirm && <Confirm {...confirm} />} */}

      {showForm === 'replaceForm' && <ReplaceWindow close={closeReplaceForm} />}
      {(showForm === 'editForm' || showForm === 'addForm') && (
        <RfidForm
          type={showForm}
          close={() => setShowForm('')}
          clientId={props.clientId}
          id={row.id}
          meanId={row.mean_id}
          meanType={row.mean_type}
          setMessage={setMessage}
          refresh={props.refresh}
          initialValues={initial}
          tariffs={props.tariffs}
        />
      )}

      {message && <GridUpdateMessage>{message}</GridUpdateMessage>}
    </GridBox>
  );
};
